var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 61,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#979797",
    fillRule: "nonzero",
    opacity: 0.6,
    cx: 19,
    cy: 59.7,
    rx: 19,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h23.1L38 10.5V44c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    fill: "#F7F7F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 10.9L26.7 1H4C2.3 1 1 2.3 1 4v40c0 1.7 1.3 3 3 3h30c1.7 0 3-1.3 3-3V10.9z",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "nonzero",
    d: "M27 0h.3L38 11.2V11H27z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 29.4c-1.7 1-3.4 1.4-4.9 1.4-1.5 0-3.1-.5-4.6-1.4M26.6 20.1c-.8.5-1.6.7-2.3.7-.8 0-1.5-.2-2.2-.7M16 20.1c-.8.4-1.6.7-2.4.7-.8 0-1.4-.3-2.2-.7"
  })))));
}
export default SvgEmptyStateHappy;